import { defineStore } from 'pinia'
import { ref } from 'vue'

import API from '@/api/apiUrls'
import type { ProjectParameterType } from '@/stores/type/projectParameter.type'
import { useBaseStore } from '@haskoning/vue-basestore'

import { useApi } from '@/api/useApi'

const api = useApi<ProjectParameterType>()

const baseUrl = API.CORE.PROJECT_PARAMETER

export const useProjectParameterStore = defineStore('projectParameter', () => {
	const baseStore = useBaseStore<ProjectParameterType>({ service: baseUrl, api })

	const filterFields = ref<string[]>(['project'])

	return {
		...baseStore,
		filterFields
	}
})
